module.exports = __webpack_public_path__ + "static_pc/img/int03.63d2058a.png";